import type { BootstrapConfig } from "@gaole/shared";

export function isMarketplaceLive(
  config: BootstrapConfig | null,
  moduleEnabled: (key: string) => boolean,
): boolean {
  return moduleEnabled("marketplace") && Boolean(config?.marketplaceEnabled);
}
